import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import JoditEditor, { Jodit } from 'jodit-react';

import Bs4GenericField from './Bs4GenericField'
import Bs4MainDispatch from '../../Bs4MainDispatch';
import tagSolid from '../../images/tag-solid.svg'

export default class Bs4TextareaHtml extends Bs4GenericField {

  setValueBs4(value) {
    //console.log('...jodit-react...setValueBs4')
    //console.log(value)
    this.setValue(value || '');
    this.resetOriginalValue()
    this.firstSetValue = true;
  }
  
  setValueJoditEditor (value) {
    this.value = value;    
    if (this.firstSetValue) {
      this.resetOriginalValue()
      this.firstSetValue = false;
    }
    this.trigger(Bs4GenericField.CHANGE_DIRTY, this, this.isDirty());
  }
  
  getConfig = () => {
    const bs = [
      'bold',		
      'italic',		
      'underline',		
      'strikethrough',		
      'eraser',		
      'ul',		
      'ol',		
      'indent',
      'outdent',		
      'align',
      'font',		
      'fontsize',
      'paragraph',		
      'classSpan',
      'brush',		
      'superscript',
      'subscript',
      'image',	
      'video',		
      'file',
      //'copyformat',
      'cut',		
      'copy',		
      'paste',		
      'selectall',		
      'hr',		
      'table',		
      'link',		
      'symbols',		
      'undo',		
      'redo',		
      'find',		
      'source',		
      //'fullsize',		
      'preview',		
      'print',		
      'about',
      'spellcheck',
    ];
      
    const bs1 = [
        'bold',		
        'italic',		
        'underline',		
        'strikethrough',		
        'eraser',		
        'ul',		
        'ol',		
        'indent',
        'outdent',		
        'align',
        'font',		
        'fontsize',
        //'paragraph',		
        //'classSpan',
        'brush',		
        //'superscript',
        //'subscript',
        //'image',	
        //'video',		
        //'file',
        //'copyformat',
        //'cut',		
        //'copy',		
        'paste',		
        'selectall',		
        //'hr',		
        'table',		
        'link',		//
        //'symbol',		
        'undo',		
        'redo',		
        'find',		
        'source',	//
        //'fullsize',		
        //'preview',		
        //'print',		
        'about',
        'spellcheck',
    ];
    
    if (this.isParamSelected('ATRYB_MINIMIZE')) {      
      //Nr 48117 - Minimalizowanie wyglądu kontrolki bs4TextareaHtml.js
      return bs1;
    } else {
      return bs;
    }
  }

  preparePaste(jodit) {
    jodit.e.on('drop', 
    e => {
      //if (confirm('Change pasted content?')) {
      //const textHtml = Jodit.modules.Helpers.getDataTransfer(e).getData(Jodit.constants.TEXT_HTML);
      //const data = Jodit.modules.Helpers.getDataTransfer(e)
      //console.log('...preparePaste(jodit) ..0.ondrop ', jodit, textHtml)
      //console.log('...preparePaste(jodit) ..1.ondrop ', data)
      if (true) {
        const textHtml = Jodit.modules.Helpers.getDataTransfer(e).getData(Jodit.constants.TEXT_HTML);
        console.log('...ondrop textHtml.0.', textHtml)
        console.log('...ondrop textHtml.e.', e)
        if (textHtml.startsWith('<img')) {
          console.log('...ondrop textHtml.1.', textHtml);
          jodit.e.stopPropagation('drop');
          jodit.s.insertHTML(textHtml)
          return false;
        }                        
      }
    },
    { top: true }
    );
    
    // jodit.e.on('paste',
    //   e => {
    //     //if (confirm('Change pasted content?')) {
    //     console.log('...preparePaste(jodit) ....', jodit)
    //     if (true) {
    //       jodit.e.stopPropagation('paste');
    //       jodit.s.insertHTML(
    //         Jodit.modules.Helpers.getDataTransfer(e)
    //           .getData(Jodit.constants.TEXT_HTML)
    //           .replace(/a/g, 'b')
    //       );
    //       return false;
    //     }
    //   },
    //   { top: true }
    // );    
  }

  handleImgPopupBs4 = (id) => {
    const details = {currFormId: this.props.field.formId, targetObjectId: id}; 
    Bs4MainDispatch.commandParser('bs4EditorTag', details, this.bs4KartotekaId);
  }

  ViewComponentField = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(() => this.getValue());
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR);
    const bs = React.useMemo(() => this.getConfig(), []);
    this.refFocus = React.useRef();
    const _ = React.useMemo(() => {
      // ?? !! 
      Jodit.plugins.add('preparePaste', this.preparePaste);
    }, []);
    const config = React.useMemo(() => {
      //// all options from https://xdsoft.net/jodit/doc/,
      const config = {       
        controls: {
          font: {
            list: {
              'Roboto Medium,Arial,sans-serif': 'Roboto'
            }
          }
        },
        style: {
          fontFamily: 'Roboto',
        },     
        spellcheck: true,
        language: 'pl',
        readonly: formField.readOnly,
        placeholder: 'Start typings...',
        width: '100%',
        //height: '100%',
        iframe: false, //Nr 48314 - Domyślna czcionka w edytorze HTML [Core]
        // iframe: true, //Nr 48314 - Domyślna czcionka w edytorze HTML [Core]
        defaultMode: "1",
        buttons: bs,
        buttonsMD: bs,
        buttonsSM: bs,
        enter: "br",
        buttonsXS: bs,
        statusbar: false,		 
        //enableDragAndDropFileToEditor: false,
        uploader: {
          insertImageAsBase64URI: true,
          url: null,
        }, 
        popup: {
          img: Jodit.atom((e, f, g) => {
            const src = f?.getAttribute('src')
            const srcs = src.split('?');
            const urlParams = new URLSearchParams('?'+srcs[1]);
            const bs4tagId = urlParams?.get('bs4tagId');
            if (bs4tagId) return [
              ...Jodit.defaultOptions.popup.img,
              {
                name: 'bs4',
                iconURL: tagSolid,
                label: 'Konfiguracja znacznika',
                tooltip: "Konfiguracja znacznika",
                exec: function (editor, target, b) {
                  // console.log('img-target', target, b)
                  // console.log('img-target-id', target.id)
                  // console.log('img-target-html', target.outerHTML)
                  formField.handleImgPopupBs4(bs4tagId)
                },                
              }
            ];
            else return Jodit.defaultOptions.popup.img;
          }),
        },  
      };

      if (formField.props?.field?.height) {
        config.height = parseFloat(formField.props.field.height)+'px';
      }
      return config;
    }, []);

    React.useEffect(() => {
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})}
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {        
        setValue(this.getValue());
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      })      
    }, [error]);        

    const handleChange = (newContent) => {
      //console.log('...jodit-react...')
      //console.log(newContent)
      this.setValueJoditEditor(newContent);
      if (Boolean(error.error)) {
        setValue(this.getValue());        
        setError(Bs4GenericField.NO_ERROR);
      }
    }    

    return (
      <FormControl 
        id={this.props.inputId}
        ref={this.refFocus}
        fullWidth 
        error={error.error}
        sx={{fontFamily: 'Roboto'}}
      >
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <JoditEditor 
          style={{fontFamily: 'Roboto'}}
          value={value}
          config={config}
          tabIndex={1} // tabIndex of textarea
          //onBlur={handleBlur} // preferred to use only this option to update the content for performance reasons
          onChange={handleChange}
        />    
        <FormHelperText>{error.helperText}</FormHelperText>
      </FormControl>
    );
  }   
}